import { nonceToHumanReadableMsg } from "@/util/crypto"
import {
  createAuthenticationAdapter,
  RainbowKitAuthenticationProvider,
} from "@rainbow-me/rainbowkit"
import { generateNonce } from "api_routes/user"
import { selectError } from "features/errorSlice"
import { loginUsersWallet } from "features/userSlice"
import useUser from "hooks/useUser"
import React, { useMemo } from "react"
import { useSelector } from "react-redux"
import { useAppDispatch } from "store"
import { useAccount } from "wagmi"

import { getCreatorReferrer } from "util/cookies"

export function RainbowKitAuthProvider({ children }: any) {
  const paragraphUser = useUser()
  const attemptedAddress = useAccount().address

  const dispatch = useAppDispatch()

  const error = useSelector(selectError)

  // If the user is logged in to Paragraph, AND their wallet matches the currently connected MetaMask wallet,
  // then consider them logged in.
  const paragraphUserWalletMatch =
    "wallet_address" in paragraphUser &&
    paragraphUser.wallet_address === attemptedAddress

  const adapter = useMemo(
    () =>
      createAuthenticationAdapter({
        createMessage: ({ address, chainId, nonce }) => {
          console.log("Creating message...", address, attemptedAddress, nonce)
          //setAttemptedAddress(address)
          return nonceToHumanReadableMsg(nonce)
        },

        getMessageBody: ({ message }) => message,

        getNonce: async () => {
          if (!attemptedAddress) {
            throw new Error("No address provided when getting nonce")
          }

          const referrerWalletAddress = getCreatorReferrer()

          const nonce = await generateNonce({
            wallet_address: attemptedAddress,

            referrerWalletAddress,
          })
          if (!nonce) {
            console.error("Unable to generate nonce")
            throw new Error("Unable to generate nonce")
          }
          return nonce
        },

        signOut: async () => {
          if (!paragraphUser.loggedIn) return
          console.warn("Signing out user after rainbowkit..")
          await paragraphUser.signoutUser()
          return
        },

        verify: async ({ message, signature }) => {
          if (!attemptedAddress) {
            console.error("No address provided when verifying signature")
            throw new Error("No address provided when verifying signature")
          }

          const loggedIn = await dispatch(
            loginUsersWallet({
              wallet_address: attemptedAddress,
              signature,
            })
          )

          console.log("Was user logged in successfully?", loggedIn)

          return !!loggedIn
        },
      }),
    [attemptedAddress]
  )

  return (
    <RainbowKitAuthenticationProvider
      adapter={adapter}
      status={
        // If error.msg is populated we want to 'pretend' that the user is authenticated,
        // so the RainbowKit wallet connect dialog will close and we display
        // the actual error message in the RainbowConnectWalletBtn component.
        paragraphUserWalletMatch || !!error.msg
          ? "authenticated"
          : "unauthenticated"
      }
    >
      {children}
    </RainbowKitAuthenticationProvider>
  )
}
